import { render, staticRenderFns } from "./crmdoctor-list.vue?vue&type=template&id=cc1b40f2&scoped=true&"
import script from "./crmdoctor-list.vue?vue&type=script&lang=js&"
export * from "./crmdoctor-list.vue?vue&type=script&lang=js&"
import style0 from "./crmdoctor-list.vue?vue&type=style&index=0&id=cc1b40f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1b40f2",
  null
  
)

export default component.exports